import defaultImage from "@/assets/images/none.png";

const FALLBACK_APPLIED = "imageFallbackApplied";
const FALLBACK_CLASS = "wido-image-fallback";
const STYLE_ID = "wido-image-fallback-style";

function normalizeUrl(src) {
  if (!src) return "";
  try {
    return new URL(src, window.location.href).href;
  } catch (_error) {
    return String(src);
  }
}

function isImageElement(target) {
  return (
    target &&
    target.tagName === "IMG" &&
    typeof target.setAttribute === "function"
  );
}

function ensureFallbackStyle() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    img.${FALLBACK_CLASS} {
      object-fit: contain !important;
      background-color: #f3f4f6;
    }
  `;
  document.head.appendChild(style);
}

/**
 * 将加载失败的 img 一次性替换为站内占位图。
 * 占位图自身如果异常，不再修改 src，避免任何形式的错误重试循环。
 */
export function applyImageFallback(target) {
  if (!isImageElement(target)) return false;

  const currentSrc = normalizeUrl(
    target.currentSrc || target.getAttribute("src") || target.src,
  );
  const fallbackSrc = normalizeUrl(defaultImage);
  const fallbackAlreadyActive = target.dataset[FALLBACK_APPLIED] === "1";

  if (fallbackAlreadyActive && currentSrc === fallbackSrc) {
    target.onerror = null;
    return false;
  }

  target.dataset[FALLBACK_APPLIED] = "1";
  target.classList.add(FALLBACK_CLASS);
  target.onerror = null;
  target.removeAttribute("srcset");
  target.src = defaultImage;
  return true;
}

/** 新地址开始加载时清除旧的占位状态，允许后续地址正常显示或再次降级。 */
export function resetImageFallback(target) {
  if (!isImageElement(target)) return;
  delete target.dataset[FALLBACK_APPLIED];
  target.classList.remove(FALLBACK_CLASS);
}

let installed = false;

/**
 * 捕获全站所有 img 的加载错误，包括没有显式 @error 的旧页面。
 * 在捕获阶段终止原错误事件，防止页面自己的 onerror 把 404 地址重新写回。
 */
export function installGlobalImageFallback() {
  if (installed || typeof document === "undefined") return;

  installed = true;
  ensureFallbackStyle();
  document.addEventListener(
    "error",
    (event) => {
      if (!isImageElement(event.target)) return;

      applyImageFallback(event.target);
      event.stopImmediatePropagation();
    },
    true,
  );
  document.addEventListener(
    "load",
    (event) => {
      if (!isImageElement(event.target)) return;

      const currentSrc = normalizeUrl(
        event.target.currentSrc || event.target.getAttribute("src"),
      );
      if (currentSrc !== normalizeUrl(defaultImage)) {
        resetImageFallback(event.target);
      }
    },
    true,
  );
}

export { defaultImage as defaultImageFallback };
